var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { Button, Flex, Typography, theme } from '@robinpowered/ui-kit';
import { useTranslation } from 'react-i18next';
import { useFeatureFlags } from '@robinpowered/dashboard-apps-common';
import { useEditEventContext } from '../composers/EditEventContext';
import { useFooterValidation } from '../hooks/useFooterValidation';
import { useState } from 'react';
import moment from 'moment';
import { useConfig } from '../context/ConfigContext';
import { useSafeFormData } from '../types/index';
import { useEventComposerGlobalContext } from '../composers/EventComposerGlobalContext';
import { buildEditLegacyComposerUrl } from '../utils/redirectToLegacyComposer';
export var EditFooterButtons = function () {
    var t = useTranslation('meetingRooms').t;
    var token = theme.useToken().token;
    var _a = useConfig(), environmentUrls = _a.environmentUrls, userContext = _a.userContext;
    var dashboardUrl = environmentUrls.dashboardUrl;
    var currentOrg = userContext.currentOrg;
    var formData = useSafeFormData();
    var startTime = formData.startTime, endTime = formData.endTime, title = formData.title, isAllDayEvent = formData.isAllDayEvent, attendeeCount = formData.attendeeCount, eventId = formData.eventId, spaces = formData.spaces;
    var timezone = useEventComposerGlobalContext().timezone;
    var _b = useEditEventContext(), handleEventUpdate = _b.handleEventUpdate, updatingEvent = _b.updatingEvent, editEventError = _b.editEventError;
    var _c = useFeatureFlags(), checkFlag = _c.checkFlag, featureFlagsLoading = _c.loading;
    var showMoreOptionsButton = !featureFlagsLoading && !checkFlag('hydra(shell-event-composer)');
    var _d = __read(useState(false), 2), isRedirectingToOldComposer = _d[0], setIsRedirectingToOldComposer = _d[1];
    var _e = useFooterValidation({
        onSubmit: handleEventUpdate,
    }), showValidationError = _e.showValidationError, handleClick = _e.handleClick, isSpaceRequestOnlyEvent = _e.isSpaceRequestOnlyEvent, isCheckingConflicts = _e.isCheckingConflicts;
    var updateEventButtonLabel = isSpaceRequestOnlyEvent
        ? t('create_event.update_request')
        : t('create_event.update');
    var redirectToOldComposer = function () {
        var _a;
        setIsRedirectingToOldComposer(true);
        if (!eventId) {
            return;
        }
        window.location.href = buildEditLegacyComposerUrl({
            dashboardUrl: dashboardUrl,
            eventId: eventId,
            title: title,
            orgId: currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.id,
            startTime: startTime,
            endTime: endTime,
            spaceId: (_a = spaces === null || spaces === void 0 ? void 0 : spaces[0]) === null || _a === void 0 ? void 0 : _a.id,
            redirectTo: window.location.href,
            attendeeCount: attendeeCount,
            timezone: timezone || moment.tz.guess(),
            isAllDayEvent: isAllDayEvent,
        });
    };
    return (_jsxs(FooterWrapper, { children: [showValidationError && (_jsx(Flex, { align: "center", gap: "4px", children: _jsx(ErrorText, { style: { color: token.colorError }, children: t('create_event.form_has_errors') }) })), _jsxs(BottomRowButtons, { children: [_jsx(Button, { variant: "dashed", type: "primary", size: "large", style: { width: '100%', flex: 1 }, onClick: handleClick, loading: (updatingEvent && !editEventError) || isCheckingConflicts, disabled: updatingEvent || isRedirectingToOldComposer, children: updateEventButtonLabel }), showMoreOptionsButton && (_jsx(Button, { variant: "dashed", size: "large", style: { width: '100%', flex: 1 }, onClick: redirectToOldComposer, loading: isRedirectingToOldComposer && !editEventError, disabled: updatingEvent, children: t('create_event.more_options') }))] })] }));
};
var FooterWrapper = styled(Flex)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n"])));
var BottomRowButtons = styled(Flex)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n"], ["\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n"])));
var ErrorText = styled(Typography.Text)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: block;\n"], ["\n  display: block;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
